import React, { useState } from 'react';
import { examService } from '../services/audiometryService';
import './ExamForm.css';

function ExamForm() {
  const [formData, setFormData] = useState({
    patientName: '',
    patientAge: '',
    patientSex: 'M',
    examDate: new Date().toISOString().split('T')[0],
    operatorName: '',
    operatorRegistration: '',
    noiseLevel: '',
    calibrationDate: '',
    transducer: 'TDH-39',
    observations: '',
  });

  const [audiogramData, setAudiogramData] = useState({
    air: {
      250: { RE: '', LE: '' },
      500: { RE: '', LE: '' },
      1000: { RE: '', LE: '' },
      2000: { RE: '', LE: '' },
      4000: { RE: '', LE: '' },
      8000: { RE: '', LE: '' },
    },
  });

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAudiogramChange = (freq, ear, value) => {
    setAudiogramData((prev) => ({
      ...prev,
      air: {
        ...prev.air,
        [freq]: {
          ...prev.air[freq],
          [ear]: value ? parseFloat(value) : null,
        },
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage(null);

    try {
      const examPayload = {
        paciente: {
          nome: formData.patientName,
          idade: parseInt(formData.patientAge),
          sexo: formData.patientSex,
        },
        data_exame: formData.examDate,
        ambiente: {
          ruido_dB: parseFloat(formData.noiseLevel),
          calibracao_atual: formData.calibrationDate,
          transdutor: formData.transducer,
        },
        audiograma: audiogramData,
        operador: {
          nome: formData.operatorName,
          registro: formData.operatorRegistration,
        },
        observacoes: formData.observations,
      };

      await examService.create(examPayload);
      setMessage({ type: 'success', text: 'Exame cadastrado com sucesso!' });
      
      // Reset form
      setFormData({
        patientName: '',
        patientAge: '',
        patientSex: 'M',
        examDate: new Date().toISOString().split('T')[0],
        operatorName: '',
        operatorRegistration: '',
        noiseLevel: '',
        calibrationDate: '',
        transducer: 'TDH-39',
        observations: '',
      });
      setAudiogramData({
        air: {
          250: { RE: '', LE: '' },
          500: { RE: '', LE: '' },
          1000: { RE: '', LE: '' },
          2000: { RE: '', LE: '' },
          4000: { RE: '', LE: '' },
          8000: { RE: '', LE: '' },
        },
      });
    } catch (error) {
      setMessage({ type: 'error', text: 'Erro ao cadastrar exame: ' + error.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="exam-form-container">
      <h1>Novo Exame Audiol�gico</h1>

      {message && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <form onSubmit={handleSubmit} className="exam-form">
        <section className="form-section">
          <h2>Dados do Paciente</h2>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="patientName">Nome *</label>
              <input
                type="text"
                id="patientName"
                name="patientName"
                value={formData.patientName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="patientAge">Idade *</label>
              <input
                type="number"
                id="patientAge"
                name="patientAge"
                value={formData.patientAge}
                onChange={handleInputChange}
                required
                min="0"
                max="120"
              />
            </div>
            <div className="form-group">
              <label htmlFor="patientSex">Sexo *</label>
              <select
                id="patientSex"
                name="patientSex"
                value={formData.patientSex}
                onChange={handleInputChange}
                required
              >
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
            </div>
          </div>
        </section>

        <section className="form-section">
          <h2>Dados do Exame</h2>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="examDate">Data do Exame *</label>
              <input
                type="date"
                id="examDate"
                name="examDate"
                value={formData.examDate}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="noiseLevel">Ru�do Ambiente (dB) *</label>
              <input
                type="number"
                id="noiseLevel"
                name="noiseLevel"
                value={formData.noiseLevel}
                onChange={handleInputChange}
                required
                step="0.1"
              />
            </div>
            <div className="form-group">
              <label htmlFor="calibrationDate">Data de Calibra��o *</label>
              <input
                type="date"
                id="calibrationDate"
                name="calibrationDate"
                value={formData.calibrationDate}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
        </section>

        <section className="form-section">
          <h2>Audiograma (Via A�rea)</h2>
          <div className="audiogram-table">
            <table>
              <thead>
                <tr>
                  <th>Frequ�ncia (Hz)</th>
                  <th>Orelha Direita (dB HL)</th>
                  <th>Orelha Esquerda (dB HL)</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(audiogramData.air).map((freq) => (
                  <tr key={freq}>
                    <td>{freq}</td>
                    <td>
                      <input
                        type="number"
                        value={audiogramData.air[freq].RE}
                        onChange={(e) =>
                          handleAudiogramChange(freq, 'RE', e.target.value)
                        }
                        step="5"
                        min="-10"
                        max="120"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={audiogramData.air[freq].LE}
                        onChange={(e) =>
                          handleAudiogramChange(freq, 'LE', e.target.value)
                        }
                        step="5"
                        min="-10"
                        max="120"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="form-section">
          <h2>Operador</h2>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="operatorName">Nome do Operador *</label>
              <input
                type="text"
                id="operatorName"
                name="operatorName"
                value={formData.operatorName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="operatorRegistration">Registro *</label>
              <input
                type="text"
                id="operatorRegistration"
                name="operatorRegistration"
                value={formData.operatorRegistration}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
        </section>

        <section className="form-section">
          <h2>Observa��es</h2>
          <div className="form-group">
            <textarea
              id="observations"
              name="observations"
              value={formData.observations}
              onChange={handleInputChange}
              rows="4"
            />
          </div>
        </section>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Salvando...' : 'Salvar Exame'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ExamForm;
